import "./index.scss";

import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectVocabData } from "../../Store/store";
import { useLocation } from "react-router-dom";
import { getSearchParams } from "../nonUIFuncs";

/**
 * Picks a part of a unit before a game starts: From Me To You's VTA groups, one
 * column each. The column under the pointer or keyboard opens up to show the
 * scene behind it.
 *
 * @param {Object} props - Component props
 * @param {Function} props.setScreen - Function to change the current screen
 * @param {Function} props.setSplitCat - Function to set the selected split category
 * @returns {JSX.Element} Screen with selectable category buttons
 */
const SplitTargetScreen = ({ setScreen, setSplitCat }) => {
  const location = useLocation();
  const params = getSearchParams(location);
  const vocabData = useSelector(selectVocabData);
  const unit = params.find((p) => p.id === "unit").value;
  const gameName = params.find((p) => p.id === "game-name").value;

  const groups = [
    ...new Set(
      vocabData
        .filter((d) => d.homeName === unit && d.subCat === gameName && d.VTA_Cat.length > 0)
        .map((d) => d.VTA_Cat),
    ),
  ];

  return (
    <div className="splittargetscreen_container">
      {groups.map((group) => (
        <button
          key={group}
          type="button"
          className="splittargetscreen_button"
          onClick={() => {
            setSplitCat(group);
            setScreen("playScreen");
          }}
          aria-label={`Select category: ${group}`}
        >
          <span className="splittargetscreen_buttontext noselect">{group}</span>
        </button>
      ))}
    </div>
  );
};

export default SplitTargetScreen;

SplitTargetScreen.propTypes = {
  setScreen: PropTypes.func,
  setSplitCat: PropTypes.func,
};
